export const BRANDING_TRANSITION_MS = 5000;
export const BRANDING_TRANSITION_FADE_SEC = 0.26;

export interface IBrandingTransitionStep {
  atMs: number;
  label: string;
}

// Said as what the world is doing, not as a percentage: the hold is a fixed five seconds rather
// than a measurement, and a bar that claimed to know how far along the re-skin is would be lying.
export const BRANDING_TRANSITION_STEPS: IBrandingTransitionStep[] = [
  { atMs: 0, label: 'Applying the configuration' },
  { atMs: 1400, label: 'Loading spots' },
  { atMs: 3100, label: 'Fetching media & assets' },
];

export const BRANDING_TRANSITION_KICKER = 'Configuration';
export const BRANDING_TRANSITION_HEADLINE = 'Restyling the map';
export const BRANDING_TRANSITION_DETAIL =
  'The new configuration is going live — the world is reloading its spots, media and assets.';
export const BRANDING_TRANSITION_HINT =
  'Keep this tab open, you stay where you are.';
